<div class="flex flex-col h-full bg-white overflow-hidden">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex items-center justify-center overflow-y-auto">
      <div class="flex flex-col gap-6 bg-white rounded-[14px] p-10 w-full max-w-[520px]">
        @if (tokenInvalid()) {
        <!-- Lien invalide ou expiré -->
        <div class="text-center">
          <h1 class="text-[19px] fg-noir-1 font-semibold tracking-tight mb-3">
            {{ 'reset_password.reset.invalid_token.title' | translate }}
          </h1>
          <p class="text-[14px] fg-gris-1 font-normal">
            {{ 'reset_password.reset.invalid_token.subtitle' | translate }}
          </p>
        </div>

        <a [routerLink]="requestRoute"
          class="w-full flex justify-center items-center h-[58px] gap-3 py-3 px-4 rounded-lg shadow-sm text-sm font-medium text-white bg-vert-1 hover:brightness-95 transition-all duration-200 cursor-pointer no-underline">
          <span class="material-icons">send</span>
          <span>{{ 'reset_password.reset.invalid_token.new_request_button' | translate }}</span>
        </a>
        } @else {
        <!-- Nouveau mot de passe -->
        <div class="text-center">
          <h1 class="text-[19px] fg-noir-1 font-semibold tracking-tight mb-3">
            {{ 'reset_password.reset.title' | translate }}
          </h1>
          <p class="text-[14px] fg-gris-1 font-normal">
            {{ 'reset_password.reset.subtitle' | translate }}
          </p>
        </div>

        <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-6 w-full">
          <div class="flex flex-col">
            <label for="reset-password" class="flex items-center gap-2 text-[14px] fg-noir-2 font-semibold mb-2">
              <span class="material-icons text-[18px]">lock_outline</span>
              {{ 'reset_password.reset.password_label' | translate }}
            </label>
            <div class="relative">
              <input id="reset-password" [type]="showPassword() ? 'text' : 'password'" formControlName="password"
                autocomplete="new-password"
                class="text-black w-full h-[58px] pl-4 pr-12 py-3 border border-gris-1-300 rounded-lg shadow-sm"
                [class.border-red-500]="form.controls.password.invalid && form.controls.password.touched" />
              <button type="button" (click)="togglePasswordVisibility()"
                [attr.aria-label]="'reset_password.reset.toggle_visibility' | translate"
                class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center bg-transparent border-0 cursor-pointer"
                [class.fg-vert-1]="showPassword()" [class.fg-gris-1]="!showPassword()">
                <span class="material-icons">{{ showPassword() ? 'visibility' : 'visibility_off' }}</span>
              </button>
            </div>
            @if (form.controls.password.touched && form.controls.password.errors; as errors) {
            <span class="text-[12px] fg-rose-1 mt-1">
              @if (errors['required']) {
              {{ 'reset_password.reset.errors.password_required' | translate }}
              } @else if (errors['passwordMinLength']) {
              {{ 'reset_password.reset.errors.password_min_length' | translate }}
              } @else {
              {{ 'reset_password.reset.errors.password_complexity' | translate }}
              }
            </span>
            } @else {
            <span class="text-[12px] fg-gris-1 mt-1">
              {{ 'reset_password.reset.password_hint' | translate }}
            </span>
            }
          </div>

          <div class="flex flex-col">
            <label for="reset-password-confirmation"
              class="flex items-center gap-2 text-[14px] fg-noir-2 font-semibold mb-2">
              <span class="material-icons text-[18px]">lock_outline</span>
              {{ 'reset_password.reset.confirmation_label' | translate }}
            </label>
            <div class="relative">
              <input id="reset-password-confirmation" [type]="showConfirmation() ? 'text' : 'password'"
                formControlName="confirmation" autocomplete="new-password"
                class="text-black w-full h-[58px] pl-4 pr-12 py-3 border border-gris-1-300 rounded-lg shadow-sm"
                [class.border-red-500]="
                  form.controls.confirmation.touched && (form.controls.confirmation.invalid || form.hasError('passwordsMismatch'))
                " />
              <button type="button" (click)="toggleConfirmationVisibility()"
                [attr.aria-label]="'reset_password.reset.toggle_visibility' | translate"
                class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center bg-transparent border-0 cursor-pointer"
                [class.fg-vert-1]="showConfirmation()" [class.fg-gris-1]="!showConfirmation()">
                <span class="material-icons">{{ showConfirmation() ? 'visibility' : 'visibility_off' }}</span>
              </button>
            </div>
            @if (form.controls.confirmation.touched && form.hasError('passwordsMismatch')) {
            <span class="text-[12px] fg-rose-1 mt-1">
              {{ 'reset_password.reset.errors.passwords_mismatch' | translate }}
            </span>
            }
          </div>

          <button type="submit" [disabled]="isSubmitting()"
            class="w-full flex justify-center items-center h-[58px] gap-3 py-3 px-4 rounded-lg shadow-sm text-sm font-medium text-white bg-vert-1 hover:brightness-95 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
            aria-label="{{ 'reset_password.reset.submit_button' | translate }}">
            @if (isSubmitting()) {
            <app-loader size="w-5 h-5" />
            } @else {
            <span class="material-icons">check</span>
            }
            <span>{{ 'reset_password.reset.submit_button' | translate }}</span>
          </button>
        </form>
        }

        <div class="text-center">
          <a class="text-[14px] fg-gris-1 font-semibold no-underline hover:brightness-95 hover:underline transition-colors duration-150"
            [routerLink]="loginRoute">
            {{ 'reset_password.back_to_login' | translate }}
          </a>
        </div>
      </div>
    </div>
  </main>
</div>
